export const FEDERATED_DSN = 'federatedDSN'
export const PROD_ALLOW_URLS = [/https?:\/\/((static|appcdn)\.)?leadconnectorhq\.com/]
export const PROPAGATION_TARGETS = [/https?:\/\/(?!(.*leadconnectorhq\.com\/qr-code\/))(.*)?leadconnectorhq\.com/]
export const SENTRY_LS_KEY = 'debug_sentry'
export const TESTING_ALLOW_URLS = ['staging.gohighlevel.com', 'localhost']
export const TESTING_PROPAGATION_TARGETS = ['localhost', /^\//]

export const SENTRY_MODULES = {
  SPM_TS: 'spm-ts',
  CONVERSATIONS_APP: 'conversationsApp',
}

export const ALLOWED_ENV = ['production']
export const SENTRY_DSN = "https://c67431ff70d6440fb529c2705792425f@o176457.ingest.sentry.io/1723141"
export const SAMPLING_RATES = {
  staging: {
    tracesSampleRate: 0.05,
    sampleRate: 0.15,
    profilesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.05,
  },
  dev: {
    tracesSampleRate: 0.05,
    sampleRate: 0.15,
    profilesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.05,
  },
  beta: {
    tracesSampleRate: 0.05,
    sampleRate: 0.15,
    profilesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.05,
  },
  production: {
    //TODO: [Do not change without discussing with Krishna (Platform Frontend) / Kiran (VP of Engineering)] Increase to 100% of traces and errors after moving to self-hosted instance & Remove Sentry Managed DSN URL
    tracesSampleRate: 0.05,
    sampleRate: 0.15,
    profilesSampleRate: 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.05,
  },
}

export const logDebuggingInfo = (message: string, ...args: any[]) => {
  const canDebug = localStorage.getItem(SENTRY_LS_KEY)

  if (canDebug) {
    console.info(`%c SENTRY_DEBUG -- ${message}`, 'color: orange; background: #000;', args)
  }
}

export const getWhitelabellingConfig = (env: string) => {
  if (env === 'production') {
    return {
      allowUrls: PROD_ALLOW_URLS,
      tracePropagationTargets: PROPAGATION_TARGETS,
    }
  }

  return {}
}
